import { render, staticRenderFns } from "./TextPanelToken.vue?vue&type=template&id=34d52358&scoped=true&"
import script from "./TextPanelToken.vue?vue&type=script&lang=js&"
export * from "./TextPanelToken.vue?vue&type=script&lang=js&"
import style0 from "./TextPanelToken.vue?vue&type=style&index=0&id=34d52358&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d52358",
  null
  
)

export default component.exports